export const HER_ACTIONS = {
  ON_MODULE_LOAD: "ON_MODULE_LOAD",
  FETCH_HEADER_DATA: "FETCH_HEADER_DATA",
  SET_HER_MODULES: "SET_HER_MODULES",
  ON_MODULE_UNLOAD: "ON_MODULE_UNLOAD"
};

export const moduleLoaded = (payload) => ({
  type: HER_ACTIONS.ON_MODULE_LOAD,
  payload: payload
});

export const moduleUnloaded = (payload) => ({
  type: HER_ACTIONS.ON_MODULE_UNLOAD,
  payload: payload
});

export const setHERModules = (payload) => ({
  type: HER_ACTIONS.SET_HER_MODULES,
  payload: payload
});